import React from "react";

const AddToDeviceGroup = ({ color }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="26.527" height="20.16" viewBox="0 0 26.527 20.16">
			<path
				id="icons8-tree-structure"
				d="M18.569,6a1.6,1.6,0,0,0-1.592,1.592v4.244a1.6,1.6,0,0,0,1.592,1.592h6.366a1.6,1.6,0,0,0,1.592-1.592V7.592A1.6,1.6,0,0,0,24.935,6Zm-2.653,4.244-5.305,3.979V15.55l5.305-3.979ZM1.592,12.366A1.6,1.6,0,0,0,0,13.958V18.2a1.6,1.6,0,0,0,1.592,1.592H7.958A1.6,1.6,0,0,0,9.55,18.2V13.958a1.6,1.6,0,0,0-1.592-1.592Zm9.019,4.244v1.326l5.305,3.979V20.59Zm7.958,2.122a1.6,1.6,0,0,0-1.592,1.592v4.244a1.6,1.6,0,0,0,1.592,1.592h6.366a1.6,1.6,0,0,0,1.592-1.592V20.324a1.6,1.6,0,0,0-1.592-1.592Z"
				transform="translate(0 -6)"
				fill={color || "#fff"}
			/>
		</svg>
	);
};

export default AddToDeviceGroup;
